
import React from 'react'

import useTranslation from '../../Hooks/UseTranslation';

import './KanbanTaskProgress.scss'

interface Props {
  percentage: number;
  status?: string;
}

const KanbanTaskProgress = ({ percentage, status }: Props) => {

  const { t } = useTranslation();

  return (
    <div className="kanban-task-progress">
      <div className="texts">
        <div className="label">{t('TASK_CARD:Progress')}</div>
        <div className="percentage">{percentage}%</div>
      </div>
      <div className={`bar ${status}`}>
        <div className="progress" style={{
          width: `${percentage || 3}%`
        }}></div>
      </div>
    </div>
  )
}

export default KanbanTaskProgress
